import {
  FilterStationFormFieldsEnum,
  PassengerMapStationFilterTypeEnum,
  yupLocalized,
} from "@ryde/shared";

export const yupFilterStationValidationSchema = {
  [FilterStationFormFieldsEnum.filterType]: yupLocalized
    .mixed<PassengerMapStationFilterTypeEnum>()
    .oneOf(Object.values(PassengerMapStationFilterTypeEnum))
    .notRequired(),
};
